<div class="rfid-card">

    <sc-master-detail [selection]="[selectedRFIDCard]" [data]="rfidCards" [newStyle]="true"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
        (deleteEntry)="onDeleteEntry($event);">

        <sc-scroll-pane>
            <form class="form" [formGroup]="formGroup">
                <sc-padding>
                    <sc-flex [vertical]="true" [stretchContent]="true" *ngIf="workingCopyDetails"
                        class="no-field-space">
                        <mat-form-field>
                            <input formControlName="nbr" name="nbr" matInput
                                placeholder="{{'number' | translate: ['tmc.admin.rfidcard.number.label', translationService.language]}}"
                                [required]="true" [maxlength]="255" />
                        </mat-form-field>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <mat-form-field>
                          <input formControlName="techIdentifier" name="techIdentifier" matInput
                              placeholder="{{'number' | translate: ['tmc.admin.rfidcard.techIdentifier.label', translationService.language]}}"
                              [required]="true" [maxlength]="255" />
                      </mat-form-field>
                      <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <mat-form-field>
                            <textarea formControlName="description" name="description" matInput
                                placeholder="{{'description' | translate: ['tmc.admin.rfidcard.description.label', translationService.language]}}"
                                [required]="false" [maxlength]="1024"></textarea>
                        </mat-form-field>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <mat-checkbox formControlName="active" name="active">
                            {{'active' | translate: ['tmc.admin.rfidcard.active.label', translationService.language]}}
                        </mat-checkbox>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'valid until' | translate: ['tmc.admin.rfidcard.valid-from.label',
                                translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="validFrom" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>{{ 'valid from' | translate: ['tmc.admin.rfidcard.valid-until.label',
                                translationService.language]}}</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="validUntil" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </sc-flex>
                </sc-padding>
            </form>
        </sc-scroll-pane>

        <ng-template masterDetailToolbar>
            <button mat-stroked-button class="config-changed-button" (click)="cancel()"
                [disabled]="!cancelEnabled">{{'cancel' | translate: ['tmc.admin.rfidcard.action.cancel',
                translationService.language]}}</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
                translate: ['tmc.admin.rfidcard.action.save',
                translationService.language]}}</button>
        </ng-template>

    </sc-master-detail>

</div>
